import React from 'react'
import {Link} from 'react-router-dom'
import he from 'he'

const ComedyContentsCard = ({item,index,hydrating}) => {

  const isTelugu = (text) => /[\u0C00-\u0C7F]/.test(text);
       
  return (
    <div  className={`comedy-contents-card ${hydrating ? 'ssr-hidden' : ''}`} >
      
               <Link className='img-anchor' to={item.url_link ? item.url_link.substring(item.url_link.indexOf('/content')) : ''} >
           <img
  src={item.stimg ? item.stimg : '/comedy/assets/images/error_img.webp'}
  alt="card-img"
  className="comedy-contents-card-img"
  loading={ index === 0 ? "eager" : index < 4 ? "auto" : "lazy"}
  fetchpriority={index === 0 ? "high"  : index < 4 ? "auto"  : "low" } />
               </Link>
              
                <Link to={item.url_link ? item.url_link.substring(item.url_link.indexOf('/content')) : ''}
                   className={`comedy-contents-card-title ${isTelugu(item.title) && item.title ? "comedy-contents-card-title-tl" : 'comedy-contents-card-title-en'}`}>{item.title ? item.title : "No Title"}</Link>
             

    </div>
  )
}

export default ComedyContentsCard;
